import React from "react";
import { Tooltip, Menu, MenuItem, IconButton } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

type ChartDownloadButtonMenuProps = {
  onDownload: (format: "png" | "jpeg") => void;
  sx?: object;
  buttonLabels?: { png?: string; jpeg?: string };
  tooltipText?: string;
};

const ChartDownloadButtonMenu: React.FC<ChartDownloadButtonMenuProps> = ({
  onDownload,
  sx = {},
  buttonLabels = {},
  tooltipText = "Download chart",
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleMenuClick = (format: "png" | "jpeg") => {
    onDownload(format);
    handleClose();
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", ...sx }}>
      <Tooltip title={tooltipText}>
          <IconButton
            onClick={handleClick}
            data-testid="export-pack-button"
            sx={{
              width: 36,
              height: 32,
              border: "1px solid #E87722",
              color: "#E87722",
              borderRadius: "8px",
              "&:hover": {
                borderColor: "#D06A1E",
                bgcolor: "#FFF7F0",
              },
            }}
            >
            <FileDownloadOutlinedIcon />
          </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={() => handleMenuClick("png")}
          sx={{ fontSize: "0.70rem", minHeight: 32, py: 0.25 }}>
          {buttonLabels.png ?? "PNG"}
        </MenuItem>
        <MenuItem onClick={() => handleMenuClick("jpeg")}
          sx={{ fontSize: "0.70rem", minHeight: 32, py: 0.25 }}>
          {buttonLabels.jpeg ?? "JPEG"}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ChartDownloadButtonMenu;